module.exports = __webpack_public_path__ + "static/media/Siege.bb45d9f3.jpg";